import React, { useState } from 'react';
import { Heart, LayoutDashboard, MessageSquare, Settings, Trash2, MapPin, ArrowRight, BarChart2 } from 'lucide-react';
import { DashboardLayout } from '../../components/DashboardLayout';
import { Link } from 'react-router-dom';
import { CompareModal } from '../../components/modals/CompareModal';
import { ScheduleVisitModal } from '../../components/modals/ScheduleVisitModal';
import { ConfirmModal } from '../../components/modals/ConfirmModal';
import { MessageModal } from '../../components/modals/MessageModal';
export function ShortlistedPlotsPage() {
  const [isCompareModalOpen, setIsCompareModalOpen] = useState(false);
  const [isVisitModalOpen, setIsVisitModalOpen] = useState(false);
  const [isConfirmModalOpen, setIsConfirmModalOpen] = useState(false);
  const [isMessageModalOpen, setIsMessageModalOpen] = useState(false);
  const [plotToRemove, setPlotToRemove] = useState<number | null>(null);
  const [plots, setPlots] = useState([{
    id: 1,
    title: 'Premium Corner Plot',
    location: 'Hinjewadi Phase 1, Pune',
    price: '₹45 Lakhs',
    size: '2,400 Sq.ft',
    image: 'bg-gray-200',
    status: 'Available'
  }, {
    id: 2,
    title: 'Lake View Plot',
    location: 'Whitefield Extension, Bangalore',
    price: '₹65 Lakhs',
    size: '1,500 Sq.ft',
    image: 'bg-gray-200',
    status: 'Price Drop'
  }, {
    id: 3,
    title: 'Commercial Land Parcel',
    location: 'Gachibowli, Hyderabad',
    price: '₹5.5 Cr',
    size: '10,000 Sq.ft',
    image: 'bg-gray-200',
    status: 'Available'
  }]);
  const [selectedPlot, setSelectedPlot] = useState<{
    title: string;
    location: string;
  } | null>(null);
  const handleScheduleVisit = (title: string, location: string) => {
    setSelectedPlot({
      title,
      location
    });
    setIsVisitModalOpen(true);
  };
  const handleRemoveClick = (plotId: number) => {
    setPlotToRemove(plotId);
    setIsConfirmModalOpen(true);
  };
  const handleConfirmRemove = () => {
    if (plotToRemove) {
      setPlots(plots.filter(p => p.id !== plotToRemove));
      setIsMessageModalOpen(true);
      setPlotToRemove(null);
    }
  };
  const navItems = [{
    label: 'Dashboard',
    icon: LayoutDashboard,
    path: '/dashboard'
  }, {
    label: 'Shortlisted Plots',
    icon: Heart,
    path: '/buyer/shortlisted'
  }, {
    label: 'My Inquiries',
    icon: MessageSquare,
    path: '/buyer/inquiries'
  }, {
    label: 'Settings',
    icon: Settings,
    path: '/buyer/settings'
  }];
  return <DashboardLayout title="My Dashboard" personaLabel="BUYER" personaColor="bg-green-100 text-green-800 border-green-200" navItems={navItems} userInitials="JD" data-id="element-3122">
      <div className="flex justify-between items-center mb-8" data-id="element-3123">
        <h1 className="text-2xl font-bold" data-id="element-3124">
          Shortlisted Plots ({plots.length})
        </h1>
        <button onClick={() => setIsCompareModalOpen(true)} className="flex items-center gap-2 px-4 py-2 bg-[#1f2933] text-white text-sm font-bold hover:bg-gray-800" data-id="element-3125">
          <BarChart2 className="w-4 h-4" data-id="element-3126" /> Compare All
        </button>
      </div>

      <div className="grid grid-cols-1 gap-6" data-id="element-3127">
        {plots.map(plot => <div key={plot.id} className="bg-white border border-gray-300 p-4 flex flex-col md:flex-row gap-6 hover:shadow-md transition-shadow" data-id="element-3128">
            <div className={`w-full md:w-48 h-32 ${plot.image} shrink-0 border border-dashed border-gray-300 flex items-center justify-center text-gray-400 text-xs`} data-id="element-3129">
              Plot Image
            </div>

            <div className="flex-1" data-id="element-3130">
              <div className="flex justify-between items-start mb-2" data-id="element-3131">
                <div data-id="element-3132">
                  {plot.status === 'Price Drop' && <span className="inline-block px-2 py-0.5 bg-green-100 text-green-800 text-[10px] font-bold uppercase mb-1 rounded-sm" data-id="element-3133">
                      Price Drop
                    </span>}
                  <h3 className="font-bold text-lg hover:text-blue-600 cursor-pointer" data-id="element-3134">
                    <Link to={`/listing/${plot.id}`} data-id="element-3135">{plot.title}</Link>
                  </h3>
                  <p className="text-gray-500 text-sm flex items-center gap-1 mt-1" data-id="element-3136">
                    <MapPin className="w-3 h-3" data-id="element-3137" /> {plot.location}
                  </p>
                </div>
                <div className="text-right" data-id="element-3138">
                  <div className="font-bold text-xl" data-id="element-3139">{plot.price}</div>
                  <div className="text-sm text-gray-500 font-mono" data-id="element-3140">
                    {plot.size}
                  </div>
                </div>
              </div>

              <div className="flex flex-wrap gap-3 mt-4 pt-4 border-t border-gray-100" data-id="element-3141">
                <button onClick={() => handleScheduleVisit(plot.title, plot.location)} className="px-4 py-2 bg-[#1f2933] text-white text-xs font-bold hover:bg-gray-800" data-id="element-3142">
                  Schedule Visit
                </button>
                <Link to={`/listing/${plot.id}`} className="px-4 py-2 border border-gray-300 text-xs font-bold hover:bg-gray-50" data-id="element-3143">
                  View Details
                </Link>
                <button onClick={() => handleRemoveClick(plot.id)} className="px-4 py-2 border border-gray-300 text-xs font-bold hover:bg-red-50 text-red-600 flex items-center gap-2 ml-auto" data-id="element-3144">
                  <Trash2 className="w-3 h-3" data-id="element-3145" /> Remove
                </button>
              </div>
            </div>
          </div>)}
      </div>

      <CompareModal isOpen={isCompareModalOpen} onClose={() => setIsCompareModalOpen(false)} data-id="element-3146" />

      {selectedPlot && <ScheduleVisitModal isOpen={isVisitModalOpen} onClose={() => setIsVisitModalOpen(false)} plotTitle={selectedPlot.title} location={selectedPlot.location} data-id="element-3147" />}

      <ConfirmModal isOpen={isConfirmModalOpen} onClose={() => setIsConfirmModalOpen(false)} onConfirm={handleConfirmRemove} title="Remove from Shortlist" message="Are you sure you want to remove this plot from your shortlist? You can always add it back later." confirmText="Remove" cancelText="Cancel" type="warning" data-id="element-3148" />

      <MessageModal isOpen={isMessageModalOpen} onClose={() => setIsMessageModalOpen(false)} title="Plot Removed" message="The plot has been removed from your shortlist successfully." type="success" data-id="element-3149" />
    </DashboardLayout>;
}